/**
 * created by wang lei
 文字居左页面
 *
 */
import React, {Component} from 'react';
import alignTextLeft from './alignTextLeft.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class AlignTextLeftTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            btnChecked: false
        }
    }

    /**
     * 监听内容变化
     */
    listenContentChange(){
        let justify = this.props.editor.queryCommandValue("justify");
        this.setState({btnChecked: justify === 'left'});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let justify = this.props.editor.queryCommandValue("justify");
        this.setState({btnChecked: justify === 'left'});
    }

    render() {
        let style = {};
        if(this.state.btnChecked){
            style.boxShadow = `-1px -1px ${EDITOR_TOOL_BTN_COLOR.checked}`;
        }else{
            if(style.boxShadow){
                delete style.boxShadow;
            }
        }
        return (
            <div style={{cursor:"pointer",...style}} onClick={()=>{
                this.props.editor.execCommand( 'justify', 'left' );
                this.setState({btnChecked:true});
            }} className={"editor-justify-left-tool-btn"}>
                <img src={alignTextLeft}/>
                <style>{`
                    .editor-justify-left-tool-btn{
                        border: 1px solid #f2f6fc;
                        line-height: 1.5;
                        height: 23px;
                        display: inline-block;
                    }
                    .editor-justify-left-tool-btn:hover{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                    }
                    .editor-justify-left-tool-btn:active{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                    }
                `}</style>
            </div>
        )
    }

}